export const formatNumber = (num: number): string => {
  // Use Intl.NumberFormat to format the number with 'en-US' locale
  const formatter = new Intl.NumberFormat("en-US");
  return formatter.format(num);
};
